import { AccountInfo } from "./sessionstore";
import { LoginDataService } from "./services/login.data.service";
import { LoginInitializer } from "./login.initializer";
import { ChangeLanguageService } from "./services/changeLanguage.service";
import { LoginStrategiesService } from "./services/login.strategies.service";
import { IdentityProvider } from "./login.repository";
import { FixedEsiaRole } from "./services/login.service";

type NcRole = "parent" | "staff"
enum NcRoles {
	Parent = "parent",
	Staff = "staff"
}

export class LoginDivaricationController {
	public accounts: AccountInfo[];
	public ready: boolean = false;

	public fixedLogin: any = null;
	public acr_values: Record<string, string | boolean>;
	public provider: IdentityProvider;
	private DEFAULT_PROVIDER = IdentityProvider.Esia;

	/*@ngInject*/
	constructor(
		private loginDataService: LoginDataService,
		private $location: ng.ILocationService,
		private loginStrategiesService: LoginStrategiesService,
	) {
		if (this.fixedLogin) {
			// вход в фисксированную организацию
			this.$location.path("/authorize/login").search({ schoolId: this.fixedLogin.schoolId });
			return;
		}

		let searchParams = new URLSearchParams(window.location.search);
		this.initAuthProvider(searchParams);

		const urlParams = this.$location.search();
		if(urlParams.acr_values) {
			this.acr_values = this.parseAcrValuesString(urlParams.acr_values)
		}

		this.loginDataService.load()
			.then(() => {
				this.ready = true;

				if (this.acr_values?.nc_role && urlParams.client_id == "ees-identity") {
					const role = this.acr_values.nc_role;
					if (role === 'parent' || role === 'staff') {
						return this.externalAcrAuth(role)
					}
				}

				this.chooseRoute();
			});
	}

	private initAuthProvider(request: URLSearchParams) {
		let ret = parseInt(request.get('provider'));
		this.provider = ret > 0 ? ret : this.DEFAULT_PROVIDER;
	}

	parseAcrValuesString(acrString: string):Record<string, string | boolean> {
		const acrPairs = acrString.split(' ')

		return acrPairs.reduce((acc, pair) => {
			const [key,value] = pair.split(':')
			if (key) {
				acc[key] = typeof value !== 'undefined' ? value : true
			}
			return acc
		}, {})
	}

	externalAcrAuth(role: NcRole) {
		if (role === NcRoles.Parent) {
			this.loginStrategiesService.loginWithEsiaProviderPermissOptions(this.provider, { esiaPermissions: true, esiaRole: FixedEsiaRole.Parents });
		}
		else if (role === NcRoles.Staff) {
			this.loginStrategiesService.loginWithEsiaProviderPermissOptions(this.provider, { esiaRole: FixedEsiaRole.AllStaffs });
		}
	}

	chooseRoute(): void {
		if (this.loginDataService.hasAccounts()) {
			this.$location.path("/authorize/accounts");
		} else {
			this.$location.path("/authorize/login");
		}
	}
}

export const LoginDivaricationComponent = {
	templateUrl: "/static/dist/app/login/login.divarication.component.html",
	controllerAs: "$ctrl",
	controller: LoginDivaricationController
}
